<template>
    <u-btn-text-underline v-bind="$attrs" color="accent" @click="$emit('click')">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-btn-text-underline>
</template>

<script>
import UBtnTextUnderline from "@/components/publish/styles/buttons/u-btn-text-underline.vue";

export default {
    props: {},
    components: {
        UBtnTextUnderline,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
